import { useAppDispatch } from "hooks/hooks";
import { useSelector } from "react-redux";
import {
  getConsumption,
  selectState,
} from "../fuelsAndLubricants.slice";
import classes from "../../../styles/AverageConsumptionModal.module.scss";
import popoverClasses from "../../../../../../components/Popover/popover.module.scss";
import { useEffect } from "react";
import { selectResourceDetails } from "../../Details/details.slice";
import Loader from "components/Loader/Loader";
import {
  averageConsumption,
  unitName,
} from "Dashboard/scenes/Resources/helpers/resourceUtil";
import { FormatDate } from "utils/dateUtils";
import { FormatNumber, FormatNumberWithUnitOrNull } from "utils/numberUtils";

const AverageConsumptionPopover = () => {
  const dispatch = useAppDispatch();
  const { averageConsumptionPopover, consumptionLoading, consumption } =
    useSelector(selectState);
  const resourceDetails = useSelector(selectResourceDetails);

  useEffect(() => {
    if (averageConsumptionPopover && resourceDetails) {
      dispatch(getConsumption(resourceDetails?.resource.resourceId));
    }
  }, [dispatch, averageConsumptionPopover, resourceDetails]);

  return (
    <div
    >
      <div className={`${classes.modalContent}`}>
        <div className="loading-container">
          {consumptionLoading && <Loader />}

          <form className={`${classes.content} ${popoverClasses.gPopoverInputs} ${popoverClasses.basicPopoverView}`}>
            <div>
              <div className={popoverClasses.directionCol}>
                <label className={popoverClasses.aboveLabel}>datum početni</label>
                <input
                  type="text"
                  readOnly
                  value={(consumption && FormatDate(consumption?.startDate)) || ""}
                />
              </div>
            </div>
            <div>
              <div className={popoverClasses.directionCol}>
                <label className={popoverClasses.aboveLabel}>
                  {consumption?.usageUnit && unitName(consumption.usageUnit)} početni
                </label>
                <input
                  type="text"
                  readOnly
                  value={consumption ? FormatNumber(consumption.startUsageAmount) : ""}
                />
              </div>
            </div>
            <div>
              <div className={popoverClasses.directionCol}>
                <label className={popoverClasses.aboveLabel}>potrošnja</label>
                <div className={classes.list}>
                  {consumption &&
                    consumption.consumptions.map((con) => (
                      <span>
                        {FormatDate(con.timeFrom)} - {FormatDate(con.timeTo)} -{" "}
                        {FormatNumberWithUnitOrNull(con.distance, unitName(consumption?.usageUnit))}{" "}
                        {averageConsumption(con)}
                      </span>
                    ))}
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div >
  );
};

export default AverageConsumptionPopover;
